import type React from 'react'
import styles from './ReportIssueRow.module.css'
import { ReportBubbleGlyph } from '../icons/SdGlyphs'
import { StationDetailsCopy } from '../copy'

export interface ReportIssueRowProps {
  onTap: () => void
  /** Row label. @defaultValue {@link StationDetailsCopy.ReportIssue} */
  label?: string
}

/**
 * Report-issue row — Figma `SD/ReportIssueRow` (6972:29531). The very
 * last element in every content state (spec F1). Speech-bubble glyph
 * (`exclamationmark.bubble`) on a 44×44 circular `background/secondary`
 * backing + label (`regularPx16` / text-primary). No chevron (spec §3 —
 * the report row is terminal). a11y id `station-details-report`.
 */
export function ReportIssueRow({
  onTap,
  label = StationDetailsCopy.ReportIssue,
}: ReportIssueRowProps): React.ReactElement {
  return (
    <button
      type="button"
      onClick={onTap}
      data-testid="station-details-report"
      className={styles.row}
    >
      <span className={styles.iconBacking} aria-hidden="true">
        <ReportBubbleGlyph size={18} className={styles.icon} />
      </span>
      <span className={styles.label}>{label}</span>
    </button>
  )
}
